export default __webpack_public_path__ + "static/hyeon-f61b1442b03de2007ac23dc1eba6f357.jpg";